export default {
  PLACEHOLDER_IMAGE: 'https://images.ctfassets.net/tjhwhh07rwer/4vtw9IJNQadFm0nJHWXPE0/5ccf4d2d25d85e3cbc548b3b20f71a57/SeedlingSide.jpeg',
};
